import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Navbar.css'
import logo from '../images/logo-2.PNG'

const Navbar = ()=>{
    return(
        <section>
            <nav className="nav-bar">
                 <div className="brand">
                    <img src={logo} className="logo-image" alt="Logo"/>
                </div>
                <ul className="links-container">
                    <li className="link Home"><a href="#Home">Home</a></li>
                    <li className="link About"><a href="#About">About</a></li>
                    <li className="link Skills"><a href="#Skills">Skills</a></li>
                    <li className="link Projects"><a href="#Projects">Projects</a></li>
                    <li className="link Contact"><a href="#Contact">Contact</a></li>
                </ul> 
                <a href="#Home" className="nav-link">
                    <i className="fas fa-home nav-icon"></i>
                    <span classname="nav-text">Home</span>
                </a>
                 <a href="#About" className="nav-link">
                    <i className="fas fa-user-alt nav-icon"></i>
                    <span classname="nav-text">About</span>
                </a>
                 <a href="#Skills" className="nav-link">
                    <i className="fas fa-star nav-icon"></i>
                    <span classname="nav-text">Skills</span>
                </a>
                <a href="#Projects" className="nav-link">
                   <i className="fas fa-tasks nav-icon"></i>
                    <span classname="nav-text">Projects</span>
                </a>
                <a href="#Contact" className="nav-link">
                    <i className="fas fa-phone-alt nav-icon"></i>
                    <span classname="nav-text">Contact</span>
                </a>
            </nav>
        </section>
    )
}

export default Navbar;